import type { Token, Tokens } from 'marked';

export const CREFERENCE_TOKEN_NAME = 'creference';

/**
 * Token emitted by the `Creference` markdown tokenizer for every
 * `[[<canonical-short-id>]]` occurrence in markdown content. The token
 * carries the inner short-id verbatim; the resolver in `Creference`
 * resolves it to an entity at render time.
 */
export interface CreferenceToken extends Tokens.Generic {
  type: typeof CREFERENCE_TOKEN_NAME;
  raw: string;
  text: string;
  /** Canonical short-id (`p3`, `v7`, `m2`, …) or version `formatted` alias `p3/4`. */
  shortId: string;
}

export function isCreferenceToken(token: Token): token is CreferenceToken {
  if (token.type !== CREFERENCE_TOKEN_NAME) {
    return false;
  }

  return 'shortId' in token;
}
